let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("6zSFk")).then(() => parcelRequire('8Q41L'));